export enum ShowAs {
    CLIENT = 'Client',
    SALES_REP = 'SalesRep',
    ADMIN = 'Admin',
    MANAGER = 'Manager',
    ANONYMOUS = 'Anonymous'
}
